<template>
  <div
    :class="containerClass"
    :data-theme="colorScheme"
    @click="onDocumentClick($event)"
  >
    <template>
      <Toast />
      <ConfirmDialog></ConfirmDialog>
    </template>
    <div class="layout-content-wrapper">
      <AppTopBar
        @menu-button-click="onMenuButtonClick"
        @search-click="toggleSearch"
      ></AppTopBar>
      <div class="layout-content">
        <!-- <AppBreadcrumb /> -->
        <router-view :key="$route.fullPath" />
      </div>
    </div>

    <AppMenu
      :model="menu"
      :layoutMode="layoutMode"
      :active="menuActive"
      :mobileMenuActive="staticMenuMobileActive"
      @menu-click="onMenuClick"
      @menuitem-click="onMenuItemClick"
      @root-menuitem-click="onRootMenuItemClick"
    ></AppMenu>
    <div class="layout-mask modal-in"></div>
    <loader></loader>
    <chatbot></chatbot>
  </div>
</template>

<script>
import EventBus from "./event-bus";
import AppTopBar from "./AppTopbar";
import AppMenu from "./AppMenu";
import Loader from "./components/Loader.vue";
import Chatbot from "./components/Chatbot.vue"
// import AppBreadcrumb from "./AppBreadcrumb.vue";
export default {
  data() {
    return {
      menuActive: false,
      layoutMode: "static",
      colorScheme: "light",
      menuTheme: "layout-sidebar-darkgray",
      overlayMenuActive: false,
      staticMenuDesktopInactive: false,
      staticMenuMobileActive: false,
      menuClick: false,
      searchActive: false,
      searchClick: false,
      userMenuClick: false,
      topbarUserMenuActive: false,
      notificationMenuClick: false,
      topbarNotificationMenuActive: false,
      rightMenuClick: false,
      rightMenuActive: false,
      configActive: false,
      configClick: false,
    };
  },
  computed: {
    menu() {
      return [
        {
          items: [
            // {
            //   label: this.$t("menu.home"),
            //   icon: "/assets/layout/images/menu_icon/Home.png",
            //   to: "/",
            // },
            {
              label: this.$t("menu.appliances"),
              icon: "/assets/layout/images/menu_icon/Appliances.png",
              to: "/appliances",
            },
            {
              label: this.$t("menu.recipes"),
              icon: "/assets/layout/images/menu_icon/Recipes.png",
              to: "/recipes",
            },
            {
              label: this.$t("menu.storage"),
              icon: "/assets/layout/images/menu_icon/Storage.png",
              to: "/storage",
            },
            {
              label: this.$t("Lista della Spesa"),
              icon: "/assets/layout/images/menu_icon/GroceryList.png",
              to: "/grocery-list",
            },
            {
              label: this.$t("menu.activity"),
              icon: "/assets/layout/images/menu_icon/Activity.png",
              to: "/activity",
            },
            {
              label: this.$t("menu.assistant"),
              icon: "/assets/layout/images/menu_icon/Assistant.png",
              to: "/assistance",
            },
            {
              label: this.$t("menu.faq"),
              icon: "/assets/layout/images/menu_icon/Vector.png",
              to: "/faq",
            },
          ],
        },
      ];
    },
    containerClass() {
      return [
        "layout-wrapper",
        {
          "layout-overlay": this.layoutMode === "overlay",
          "layout-static": this.layoutMode === "static",
          "layout-slim": this.layoutMode === "slim",
          "layout-sidebar-dim": this.colorScheme === "dim",
          "layout-sidebar-dark": this.colorScheme === "dark",
          "layout-overlay-active": this.overlayMenuActive,
          "layout-mobile-active": this.staticMenuMobileActive,
          "layout-static-inactive":
            this.staticMenuDesktopInactive && this.layoutMode === "static",
          "p-input-filled": this.$appState.inputStyle === "filled",
          "p-ripple-disabled": !this.$primevue.config.ripple,
        },
        this.colorScheme === "light" ? this.menuTheme : "",
      ];
    },
    email: function() {
      return this.$store.getters["userdata/getEmail"];
    },
    access_token: function() {
      return this.$store.getters["userdata/getAccessToken"];
    },
  },
  components: {
    AppTopBar,
    AppMenu,
    Loader,
    Chatbot
    // AppBreadcrumb,
  },
  watch: {
    $route() {
      this.menuActive = false;
      this.$toast.removeAllGroups();
    },
    email: "checkUserdata",
    access_token: "checkUserdata",
  },
  created() {
    this.$store.dispatch("userdata/init");
    this.checkUserdata();
  },

  methods: {
    checkUserdata() {
      if (this.access_token == null) {
        console.log("You are not logged in!");

        this.$router.push({ name: "login" });
      }
    },
    onDocumentClick() {
      if (!this.searchClick && this.searchActive) {
        this.onSearchHide();
      }

      if (!this.userMenuClick) {
        this.topbarUserMenuActive = false;
      }

      if (!this.notificationMenuClick) {
        this.topbarNotificationMenuActive = false;
      }

      if (!this.rightMenuClick) {
        this.rightMenuActive = false;
      }

      if (!this.menuClick) {
        if (this.isSlim()) {
          EventBus.emit("reset-active-index");
          this.menuActive = false;
        }

        if (this.overlayMenuActive || this.staticMenuMobileActive) {
          this.hideOverlayMenu();
        }

        this.unblockBodyScroll();
      }

      if (this.configActive && !this.configClick) {
        this.configActive = false;
      }

      this.searchClick = false;
      this.configClick = false;
      this.userMenuClick = false;
      this.rightMenuClick = false;
      this.notificationMenuClick = false;
      this.menuClick = false;
    },
    onMenuClick() {
      this.menuClick = true;
    },
    onMenuButtonClick(event) {
      this.menuClick = true;
      this.topbarUserMenuActive = false;
      this.topbarNotificationMenuActive = false;
      this.rightMenuActive = false;

      if (this.isOverlay()) {
        this.overlayMenuActive = !this.overlayMenuActive;
      }

      if (this.isDesktop()) {
        this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
      } else {
        this.staticMenuMobileActive = !this.staticMenuMobileActive;
        if (this.staticMenuMobileActive) {
          this.blockBodyScroll();
        } else {
          this.unblockBodyScroll();
        }
      }

      event.preventDefault();
    },
    onMenuItemClick(event) {
      if (!event.item.items) {
        EventBus.emit("reset-active-index");
        this.hideOverlayMenu();
      }
      if (!event.item.items && this.isSlim()) {
        this.menuActive = false;
      }
    },
    onRootMenuItemClick() {
      this.menuActive = !this.menuActive;
    },
    onTopbarUserMenuButtonClick(event) {
      this.userMenuClick = true;
      this.topbarUserMenuActive = !this.topbarUserMenuActive;

      this.hideOverlayMenu();

      event.preventDefault();
    },
    onTopbarNotificationMenuButtonClick(event) {
      this.notificationMenuClick = true;
      this.topbarNotificationMenuActive = !this.topbarNotificationMenuActive;

      this.hideOverlayMenu();

      event.preventDefault();
    },
    toggleSearch() {
      this.searchActive = !this.searchActive;
      this.searchClick = true;
    },
    onSearchClick() {
      this.searchClick = true;
    },
    onSearchHide() {
      this.searchActive = false;
      this.searchClick = false;
    },
    onRightMenuClick() {
      this.rightMenuClick = true;
    },
    onRightMenuButtonClick(event) {
      this.rightMenuClick = true;
      this.rightMenuActive = !this.rightMenuActive;
      this.hideOverlayMenu();
      event.preventDefault();
    },
    onConfigClick() {
      this.configClick = true;
    },
    onConfigButtonClick() {
      this.configActive = !this.configActive;
      this.configClick = true;
    },
    hideOverlayMenu() {
      this.overlayMenuActive = false;
      this.staticMenuMobileActive = false;
      this.unblockBodyScroll();
    },
    blockBodyScroll() {
      if (document.body.classList) {
        document.body.classList.add("blocked-scroll");
      } else {
        document.body.className += " blocked-scroll";
      }
    },
    unblockBodyScroll() {
      if (document.body.classList) {
        document.body.classList.remove("blocked-scroll");
      } else {
        document.body.className = document.body.className.replace(
          new RegExp(
            "(^|\\b)" + "blocked-scroll".split(" ").join("|") + "(\\b|$)",
            "gi"
          ),
          " "
        );
      }
    },
    isSlim() {
      return this.layoutMode === "slim";
    },
    isOverlay() {
      return this.layoutMode === "overlay";
    },
    isDesktop() {
      return window.innerWidth > 991;
    },
  },
};
</script>

<style lang="scss">
@import "App.scss";
</style>
